<template>
  <el-dialog :title="title" :visible.sync="isShowLoginForm"
    :closeOnClickModal="false"
    class="medium register-dialog"
    @open="onOpen"
    :custom-class="loading ? 'loading' : ''"
   >
    <div v-if="isLoginForm">
      <el-form :model="form">
        <el-form-item :label="$t('TEXT_EMAIL_OR_USERNAME')" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('TEXT_PASSWORD')" :label-width="formLabelWidth">
          <el-input v-model="form.password" autocomplete="off" @keyup.enter.native="login()" type="password"></el-input>
        </el-form-item>
        <div class="slidercaptcha card">
          <div class="card-header">
              <span>Slide to verify</span>
          </div>
          <div class="card-body">
              <div id="captcha"></div>
          </div>
        </div>
        <el-form-item class="item-link text-right">
          <span @click="forgotPassword"
          >Forgot password?</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="login" :disabled="!isValidated" class="btn btn-primary mt-2"
        >{{ $t('BTN_LOGIN') }}</el-button>
      </span>
      <div class="item-divider"></div>
      <div class="item-link">
        <span @click="forgotOTP"
        ><i class="el-icon-lock"></i>Forgot 2FA?</span>
      </div>
      <div class="item-link">
        <span @click="resendEmail"
        ><i class="el-icon-message"></i>Resend Email Activation</span>
      </div>
    </div>
    <div v-else>
      <el-form :model="resendForm" @submit.prevent.native="resend">
        <el-form-item :label="$t('TEXT_EMAIL')" :label-width="formLabelWidth">
          <el-input v-model="resendForm.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="mt-2">
        <a @click="back"
        >Back</a>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="resend" :disabled="!isValidatedResendForm" class="btn btn-primary mt-2"
        >Resend</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      title: 'Login',
      form: {
        email: '',
        ref_code: '',
        password: ''
      },
      formLabelWidth: '120px',
      isLoginForm: true,
      resendForm: { email: '' },
      recaptcha: null
    }
  },
  computed: {
    isShowLoginForm: {
      get () {
        return this.$store.getters.isShowLoginForm
      },
      set (val) {
        this.$store.dispatch('toggleLoginFormModal')
        this.$store.dispatch('closeAllModal')
      }
    },
    configs () {
      return this.$store.getters.configs
    },
    isValidatedResendForm () {
      return this.resendForm.email
    },
    isValidated () {
      return this.form.email && this.form.password
    },
    account () {
      return this.$store.getters.account
    }
  },
  mounted () {

  },
  methods: {
    forgotOTP () {
      this.$prompt('Please enter email', 'Forgot OTP', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/
      }).then(({ value }) => {
        this.loading = true
        const requestData = { email: value }
        this.$store.dispatch('forgotOTP', requestData).then(rs => {
        }).finally(() => {
          this.loading = false
        })
      }).catch(() => {
      })
    },
    resendEmail () {
      this.isLoginForm = false
      this.title = 'Resend activation form'
    },
    back () {
      this.isLoginForm = true
      this.title = 'Login'
    },
    forgotPassword () {
      this.$store.dispatch('toggleForgotPasswordFormModal')
    },
    toggleModal () {
      this.$store.dispatch('toggleLoginFormModal')
      this.$store.dispatch('closeAllModal')
    },
    onOpen () {
      this.form.address = this.account.address
      const ref = this.$route.query.ref
      ref && (this.form.refAddress = ref)
      setTimeout(() => {
        this.recaptcha = window.sliderCaptcha({
          id: 'captcha',
          width: 280,
          height: 150,
          sliderL: 42,
          sliderR: 9,
          offset: 5,
          loadingText: 'Loading...',
          failedText: 'Try again',
          barText: 'Slide right to fill',
          repeatIcon: 'fa fa-redo',
          // remoteUrl: 'https://api.redrivergate.com/api/v1/verify-recaptcha',
          setSrc: function () {
            const url = 'https://picsum.photos/200/300'
            return url
          },
          onSuccess: function () {
            // var handler = setTimeout(function () {
            //   window.clearTimeout(handler)
            //   this.captcha.reset()
            // }, 500)
            console.log(window.recaptcha)
          }
        })
      }, 500)
    },
    async resend () {
      if (!this.isValidatedResendForm) return
      this.loading = true
      await this.$store.dispatch('resendVerifyEmail', this.resendForm)
      this.loading = false
    },
    goToDashboard () {
      this.$store.dispatch('toggleLoginFormModal')
      this.$store.dispatch('closeAllModal')
      this.$router.push({ name: 'Dashboard' })
    },
    login () {
      if (!this.isValidated) return
      this.loading = true
      this.$store.dispatch('login', this.form).then(rs => {
        if (rs.status) {
          this.goToDashboard()
        } else if (rs.message === 'MSG_LOGIN_MUST_USE_TWO_FA' || rs.message === 'MSG_USER_TWO_FA_VERIFICATION_CODE_INVALID') {
          this.$prompt('Please enter one time code', '2FA Code', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[0-9]+/
          }).then(({ value }) => {
            this.loading = true
            this.form.code = value
            this.login()
          }).catch(() => {
          })
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.slidercaptcha {
    margin: 0 auto;
    width: 314px;
    height: 286px;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.125);
    margin-top: 40px;
}

    .slidercaptcha .card-body {
        padding: 1rem;
    }

    .slidercaptcha canvas:first-child {
        border-radius: 4px;
        border: 1px solid #e6e8eb;
    }

    .slidercaptcha.card .card-header {
        background-image: none;
        background-color: rgba(0, 0, 0, 0.03);
    }

.refreshIcon {
    top: -54px;
}
</style>
